import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import * as actions from '../../actions';

// IMAGES
import stepEightBathtub from '../../assets/images/stepEightBathtub.svg';
import ImageContainer from '../image-handler/ImageContainer';
import FormInputField from '../forms/FormInputField';
import FormInput from '../forms/FormInput';
import FaQuestionCircle from 'react-icons/lib/fa/question-circle';

class Step8 extends Component {

    render() {
        return (
            <div className='wt-step-8 step-content'>
                <div className='row'>
                    <h5 className='col s6' >
                        {this.props.translate('BATHTUB.stepEight.menu.title')}
                    </h5>
                </div>
                <div className='row'>
                    <div className='col s11'>
                        <FormInput
                            type='checkbox'
                            labelPosition='inline'
                            labelName={this.props.translate('BATHTUB.stepEight.form.system')}
                            name='BATHTUB.MISSING_SOUNDSYSTEM'
                            value={this.props.bathtub.MISSING_SOUNDSYSTEM.CurrentValue}
                            checked={this.props.bathtub.MISSING_SOUNDSYSTEM.CurrentValue === '1'}
                            disabled={this.props.bathtub.SOUNDSYSTEM && this.props.bathtub.SOUNDSYSTEM.Values.Value.length < 2}
                            divClass='col s12 m3'/>
                    </div>
                    <div className='col s1 right-align'>
                        <FaQuestionCircle className='right-align' style={{fontSize: '20px'}} />
                    </div>
                    <div className='col s12'>
                        <FormInput
                            type='select'
                            options={this.props.bathtub.SOUNDSYSTEM && this.props.bathtub.SOUNDSYSTEM.Values.Value}
                            name='BATHTUB.SOUNDSYSTEM'
                            value={this.props.bathtub.SOUNDSYSTEM && this.props.bathtub.SOUNDSYSTEM.CurrentValue}
                            checked={this.props.bathtub.SOUNDSYSTEM && this.props.bathtub.SOUNDSYSTEM.CurrentValue === '0' ? '00' : (this.props.bathtub.SOUNDSYSTEM  && this.props.bathtub.SOUNDSYSTEM.CurrentValue)}
                            disabled={this.props.bathtub.MISSING_SOUNDSYSTEM.CurrentValue !== '1'}
                            divClass='col s12 m3'/>
                    </div>
                </div>
                <div className='row'>
                    <ImageContainer
                        image={this.props.image.Image}
                        name='bathtub'
                        divClass='col xl10 offset-xl1'
                        height='100%' />
                </div>
            </div>
        )
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
Step8.propTypes = {
    stepControl: PropTypes.func.isRequired,
    bathtub:     PropTypes.object.isRequired,
    translate:   PropTypes.func.isRequired,
};

function mapStateToProps({bathtub, locale, image}) {
    return {
        bathtub,
        translate: getTranslate(locale),
        image,
    }
}

export default connect(mapStateToProps, actions)(Step8);



// WEBPACK FOOTER //
// ./src/components/bathtub-steps/Step8.js